import React from 'react';

import { isNumber } from 'lodash-es';
import { useIntl } from 'react-intl';

import { IRewardFragment, Maybe } from 'generated/graphql-gateway';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { POINTS_TRANSLATION_KEY } from '../incentive-details/constants';
import { RewardPointCost } from '../reward-point-cost';

import {
  PointTextContainer,
  PointsNeededContainer,
  PointsNeededLockIcon,
  PointsNeededText,
  StyledPointsIcon,
  StyledProgressMeter,
} from './incentive-card.styled';

export const RewardCardContent = ({ engineReward }: { engineReward: Maybe<IRewardFragment> }) => {
  const { formatMessage } = useIntl();
  const meterEnabled = Boolean(useFlag(LaunchDarklyFlag.ENABLE_METER_ON_REWARDS));

  if (!engineReward) {
    return null;
  }

  const { pointCost, locked, redemptionPercentage, remainingPointsNeededForRedemption } =
    engineReward;

  return (
    <>
      {isNumber(pointCost) && (
        <PointTextContainer>
          <StyledPointsIcon />
          <RewardPointCost pointCost={pointCost}>{pointCost}</RewardPointCost>
        </PointTextContainer>
      )}
      {locked && (
        <>
          {meterEnabled && isNumber(redemptionPercentage) && (
            <StyledProgressMeter percentage={redemptionPercentage} />
          )}
          {remainingPointsNeededForRedemption && (
            <PointsNeededContainer>
              <PointsNeededLockIcon />
              <PointsNeededText>
                {formatMessage(
                  { id: 'yourXPointsAway' },
                  {
                    points: <span>{remainingPointsNeededForRedemption}</span>,
                    pointsSlang: POINTS_TRANSLATION_KEY,
                  }
                )}
              </PointsNeededText>
            </PointsNeededContainer>
          )}
        </>
      )}
    </>
  );
};
